import { milliseconds } from 'date-fns';

export default [
    function initial(_options, _version) {
        //  no action
    },
    function addStartOfNextDayOption(options, _version) {
        // start at 4am by default
        options.startNextDay = milliseconds({ hours: 4 });
    },
    function renameDeletedToArchived(options, _version) {
        options.showArchived = options.showDeleted ?? false;
        delete options.showDeleted;
    },
    function addCalendarOptions(options, _version) {
        options.showWeekNumbers = false;
        options.firstDayOfWeek = 1;
    },
    function addLocaleOption(options, _version) {
        options.currentLocale = null;
    },
    function addThemeOption(options, _version) {
        options.theme = 0;
    },
    function ensureFirstDayOfWeekIsNumber(options, _version) {
        options.firstDayOfWeek = Number(options.firstDayOfWeek);
    },
];